import {
  DIM2CLASS
} from '../../core/icon-class';
import {
  Filter
} from '../../common/filter';
import {
  boolDialogCtrl
} from '../../admin/modals';
import {
  getFilterIcon
} from '../../common/filter-mode';
import {
  RegExpConstructorModalController
} from './regexp-constructor/regexp-constructor-modal.component.js';

require('./filter-editor-modal.component.scss');

export const FilterEditorModalController = function(
  $scope,
  $http,
  $modal,
  $timeout,
  $modalInstance,
  FilterResource,
  Aggregates,
  filter,
  CurrentFilterService,
  FilterDataFactory,
  CurrentModelService,
  FilterEditorService,
  model,
  asNew,
  globalAlert,
  ErrorHandlerService,
  StatusCheckerService,
  RouterService,
  tabName,
) {
  $scope.testMail = true;
  $scope.notify2 = {};
  $scope.$timeout = $timeout;
  $scope.successSended = false;
  let jastOpened = true;
  $scope.model = model;
  $scope.$http = $http;
  $scope.ErrorHandlerService = ErrorHandlerService;
  $scope.CurrentFilterService = CurrentFilterService;
  $scope.RouterService = RouterService;
  this.CurrentModelService = CurrentModelService;
  $scope.visibleDimensions = model.dimensions;
  $scope.DIM2CLASS = DIM2CLASS;
  $scope.cube = model.cubes[0];
  $scope.filterAsText = {};
  $scope.awaiting = false;
  $scope.warningMessage = '';
  $scope.errorMessage = $scope.ErrorHandlerService.filterErrorMessage || {};
  if (!('fields' in $scope.errorMessage)) $scope.errorMessage.fields = {};
  $scope.errorMessage.filterUnchecked = false;
  $scope.errorMessage.notReload = true;
  $scope.ErrorHandlerService.notShowErrorMessageBox = true;
  $scope.filterBar = new Filter('DialogBar');
  $scope.filter = angular.copy(filter);
  $scope.filterData = FilterDataFactory(true);
  if (asNew) {
    delete $scope.filter.id;
    $scope.filter.saved = false;
    $scope.CurrentFilterService.setFilterName($scope.filter);
  }

  if ($scope.filter.isCardFilter && $scope.CurrentFilterService.filter.id === $scope.filter.id)
    $scope.filter.children = $scope.CurrentFilterService.filter.children;
  $scope.filterBar.skipStat = true;
  $scope.filterBar.limit = 100;
  $scope.serverPolicies = false;
  $scope.showDeleteButton = true;
  $scope.StatusChecker = StatusCheckerService;

  const tabs = {
    QueryTab: {
      currentTab: 'filters',
      filterTab: 'query'
    },
    notify: {
      currentTab: 'notify',
      filterTab: 'filter'
    },
    filters: {
      currentTab: 'filters',
      filterTab: 'filter'
    },
    code: {
      currentTab: 'filters',
      filterTab: 'code'
    },
    prop: {
      currentTab: 'prop',
      filterTab: 'filter'
    }
  };

  if (!(tabName && tabName in tabs)) tabName = 'prop';
  // $scope.RouterService.tabName = tabName;

  $scope.currentTab = tabs[tabName].currentTab;
  $scope.filterTab = tabs[tabName].filterTab;

  $scope.setTab = tab => {
    $scope.currentTab = tab;
    if (tab === 'prop') $scope.RouterService.tabName = 'prop';
    else if (tab === 'filters') $scope.RouterService.tabName = 'filters';
    else if (tab === 'notify') $scope.RouterService.tabName = 'notify';
    $scope.$broadcast('changeTab');
  };

  $scope.setFilterTab = tab => {
    $scope.filterTab = tab;
    if (tab === 'code') $scope.RouterService.tabName = 'code';
    else if (tab === 'filter') $scope.RouterService.tabName = 'filters';
    else if (tab === 'query') $scope.RouterService.tabName = 'QueryTab';
  };
  $scope.colorOpened = false;
  $scope.filter.search_color = String($scope.filter.search_color || 0);

  $scope.setColor = (color, event) => {
    $scope.filter.search_color = color;
  };

  $scope.getOriginalFilter = (id) => {
    if ($scope.originalFilter) return $scope.originalFilter;
    if (!id) id = $scope.filter.id;
    if (!id) return null;
    $scope.originalFilter = CurrentFilterService.FiltersService.findById(id);
    return $scope.originalFilter;
  };

  $scope.emailTemplete = {
    show: false
  };
  $scope.setTrueemailTemplete = () => $scope.emailTemplete.show = true;

  $scope.isFilterChanged = () => {
    if (!$scope.filter.id) {
      $scope.filter.isChanged = true;
      return true;
    }
    $scope.filter.isChanged = false;
    const f = new Filter();
    $scope.filter.isChanged = !angular.equals($scope.getOriginalFilter(), $scope.filter);
    return $scope.filter.isChanged;
  };

  const bypassTypes = ['filter', 'dashboard', 'folder', 'backupfilter', 'stamprecognition', 'graphicobjects', 'deletepolicy'];
  $scope.showApplyType = () => {
    return !bypassTypes.includes($scope.filter.content_type);
  };

  const initApplyType = () => {
    $scope.filter.applyType = $scope.filter.id ? 'continue' : 'new';
  };

  if ($scope.showApplyType()) initApplyType();
  $scope.toggleDo_scan = () => {
    if ($scope.filter.do_scan) {
      $scope.filter.notify = false;
      $scope.filter.report_if_filter_data_exists = false;
    } else {
      if ($scope.showApplyType()) initApplyType();
    }
  };

  $scope.filterIcon = () => getFilterIcon($scope.filter);

  $scope.filterHeader = () => {
    if (!$scope.filter.content_type) return $scope.filter.name;
    const type = $scope.CurrentFilterService.PermissionService.types[$scope.filter.content_type];
    return type && $scope.filter.name !== type.name ? `${type.name}: ${$scope.filter.name}` : `${$scope.filter.name}`;
  };

  $scope.updateAsText = () => {
    $scope.filterAsText.code = $scope.filter.getCutsCode();
    if ($scope.errorMessage.source !== 'query-text') {
      $scope.findFilterError('query-filter');
    }
  };

  $scope.findFilterError = type => {
    $scope.errorMessage.error = false;
    const setFieldNumError = (field, message = '') => {
      if (!angular.isNumber($scope.filter[field]) || $scope.filter[field] < 0) {
        $scope.errorMessage.fields[field] = gettext('Введите положительное целое число') + message;
        $scope.errorMessage.error = true;
      }
    };

    if ($scope.filter.content_type === 'deletepolicy')
      $scope.warningMessage = gettext('Вы уверены в правильности выбора данных? Удалённые данные восстановить нельзя.');

    $scope.errorMessage.source = type;


    if ($scope.CurrentFilterService.iFrameParams) Object.assign($scope.filter, $scope.CurrentFilterService.iFrameParams);

    if ($scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter') {
      $scope.changeFilterTimeout();
      if (!$scope.filter.timeout || $scope.filter.timeout === '0:0') {
        $scope.errorMessage.fields['timeout'] = gettext('Введите данные в формате "чч:мм"');
        $scope.errorMessage.error = true;
      }
    }

    if ($scope.filter.content_type === 'ocrparser' && $scope.filter.action === 'abbyy') {
      if ($scope.filter.ocr_app_id == '' || $scope.filter.ocr_app_password == '') {
          $scope.errorMessage.text = gettext('Укажите AppID и пароль');
        $scope.errorMessage.error = true;
      }
    }

    if ($scope.filter.content_type === 'corpusprocessfilter') {
      if (!$scope.filter.corpus_data) {
        $scope.errorMessage.text = gettext('Заполните словарь');
        $scope.errorMessage.error = true;
      }
    }

    if (filter.content_type === 'backupfilter') {
      setFieldNumError('hdd_alarm_percentage');
      setFieldNumError('hdd_hard_percentage');
      setFieldNumError('database_alarm_percentage');

      if ($scope.filter.hdd_backup_path == '') {
        $scope.errorMessage.fields['hdd_backup_path'] = gettext('Задайте путь резервного копирования');
        $scope.errorMessage.error = true;
      }
    }

    if ($scope.filter.content_type === 'withdrawallicenseagent') {
      setFieldNumError('inactivity_days');
    }

    if ($scope.filter.content_type === 'mailgrabber') {
      if ($scope.filter.messages_deletion_policy === undefined) {
        $scope.filter.messages_deletion_policy = '1';
      }
      if ($scope.filter.messages_deletion_policy === '3') {
        setFieldNumError('delete_messages_after_days');
      } else {
        $scope.filter.delete_messages_after_days = null;
      }
    }

    if ($scope.filter.name == '') {
      $scope.errorMessage.text = gettext('Задайте имя фильтра');
      $scope.errorMessage.error = true;
    }


    // if (type !== $scope.errorMessage.source) return;
    if (!$scope.errorMessage.error && !$scope.ErrorHandlerService.isWrongCuts($scope.filter.filters)) {
      const errorMessage = $scope.filter.getFilterError();
      $scope.errorMessage.text = errorMessage.text;
      $scope.errorMessage.fields = errorMessage.fields;
      $scope.errorMessage.error = errorMessage.error;
      if (!$scope.errorMessage.error)
        $scope.errorMessage.text = this.CurrentModelService.model.checkIsFilterCutsValueAllowed($scope.filter);
    }
    if ($scope.errorMessage.error) {
      $scope.awaiting = false;
    }

    $scope.errorMessage.filterUnchecked = false;
  };

  $scope.$watch('filter', () => {
    $scope.errorMessage = {
      fields: {}
    };
    $scope.findFilterError('data-filter');
    if ($scope.filter.isAnalyticPolitic) {
      const regs = $scope.filter.corpus_data ? $scope.filter.corpus_data.split('\n').filter(w => w[0] === '~') : [];

      FilterResource.checkRegExps(regs).then(err => {
        if (err) {
          return $scope.errorMessage.text = err;
        }
      });
    }
    $scope.updateAsText();
    if (jastOpened) jastOpened = false;
    else if ($scope.filter.isPolitic) $scope.filterData.update($scope.filter);
  }, true);

  $scope.updateFromText = () => {
    $scope.filter.from_text($scope.filterAsText.code);
    $scope.findFilterError('data-filter');
    queryAsTextChange();
  };

  $scope.onQueryTextGotFocus = () => {
    $scope.errorMessage.filterUnchecked = true;
    $scope.errorMessage.text = gettext('Для сохранения кода фильтра переместите фокус мышки из текстового редактора на любую другую часть формы');
  };

  const isValidQueryText = text => {
    return !!text.match(/(?=.*\boperator\b)*(?=.*\brules\b)/);
  };

  const queryAsTextChange = () => {
    try {
      const query = Filter.getQueryFromText($scope.filterAsText.code);
      if (!angular.equals($scope.filter.query, query)) $scope.filter.query = query;
    } catch (err) {
      $scope.errorMessage.text = err.message;
      $scope.errorMessage.source = 'query-text';
      console.error(err.message);
    }
  };

  $scope.openNodes = {};

  $scope.locLabel = Filter.locLabel;

  $scope.isNodeOpen = function(type, obj) {
    return $scope.openNodes[type] == obj;
  };

  $scope.closeNode = function(type, obj) {
    console.log(type, obj);
    $scope.openNodes[type] = false;
  };

  $scope.switchNode = function(type, obj, $event) {
    if ($scope.isNodeOpen(type, obj)) $scope.closeNode(
      type,
      obj,
    );
    else $scope.openNode(type, obj);
    if ($event) $event.stopPropagation();
  };

  $scope.openNode = function(type, obj) {
    $scope.closeNode(type, obj);
    $scope.openNodes[type] = obj;
  };

  $scope.cells = function() {
    return $scope.aggregate ? $scope.aggregate.cells : [];
  };

  $scope.loadAggregate = function(callback, resetCache) {
    if ($scope.aggregate) {
      $scope.aggregate.blocked = true;
    }
    if (resetCache) $scope.filterBar.page = 0;
    const canceler = null;
    $scope.filterBar.copyFrom($scope.filter, true);
    delete $scope.filterBar.timeFrom;
    delete $scope.filterBar.timeTo;
    $scope.drill = $scope.filterBar.drilldown[0];

    if ($scope.filter.content_type === 'backupfilter' || $scope.filter.content_type === 'withdrawallicenseagent') {
      $scope.serverPolicies = true;
    }

    if (!$scope.filter.id || $scope.filter.id < 1000 || $scope.serverPolicies) {
      $scope.showDeleteButton = false;
    }

    if ($scope.aggregate && $scope.filterBar.page === 0) {
      $scope.aggregate = null;
    }
    $scope.drill = $scope.filterBar.drilldown[0];
    Aggregates.load(
        $scope.cube.name,
        $scope.filterBar,
        resetCache,
        canceler,
      )
      .then((aggregate) => {
        if (aggregate) {
          if (!$scope.aggregate || !$scope.filterBar.page) {
            $scope.aggregate = aggregate;
            $scope.aggregate.isComplete = false;
          } else {
            $scope.aggregate.isComplete = aggregate.cells.length == 0;
            aggregate.cells.forEach(function(cell) {
              $scope.aggregate.cells.push(cell);
            }, this);
          }
        }
        if ($scope.aggregate) {
          $scope.aggregate.blocked = false;
        }
        $scope.$broadcast('aggregateLoaded');
      })
      .catch(error => {
        ErrorHandlerService.handle(error);
      });
  };

  $scope.aggregate_more = function() {
    if (!$scope.filterBar) return;
    const blocked = $scope.aggregate ? $scope.aggregate.blocked : true;
    $scope.filterBar.page = blocked ? $scope.filterBar.page : $scope.filterBar.page + 1;
    if (!blocked) $scope.loadAggregate(function(error) {
      if (error) globalAlert(error.message);
    }, false);
  };

  $scope.searchAggregate = function(event) {
    if (event && event.keyCode != 13) return false;
    const keyword = angular.element('#aggregate-search-modal').val();
    $scope.filterBar.lookup = keyword;
    $scope.loadAggregate(function(error) {
      if (error) globalAlert(error.message);
    }, true);
  };

  $scope.loadAggregate(null, true);

  $scope.isAggregateLoading = function() {
    return !$scope.aggregate || $scope.aggregate.blocked;
  };

  $scope.hasData = function() {
    return ($scope.aggregate && $scope.aggregate.cells && $scope.aggregate.cells.length > 0);
  };

  $scope.select = function(dim) {
    if (dim.dimension) {
      $scope.openNode('hierarhy', dim.toString());
      $scope.openNode('dimension', dim.dimension.toString());
    } else {
      $scope.openNode('dimension', dim.toString());
    }
    $scope.filterBar.setDrilldown(dim.toString());
    $scope.filterBar.setKeyword('');
    $scope.filterBar.page = 0;
    $scope.filterBar.lookup = null;
    $scope.loadAggregate();
  };

  $scope.$on('reload', () => $scope.loadAggregate(null, true));

  $scope.hasCellFilter = function(drill, cell) {
    const filter = $scope.model.getCellFilter(drill, cell);
    return $scope.filter.hasFilter(filter);
  };

  $scope.focusName = function() {
    // if (!$scope.filter.saved) {
    //   $scope.filter.name = '';
    // }
  };

  $scope.cleanName = function() {
    $scope.filter.name = '';
  };


  $scope.invertFilter = f => {
    $scope.filter.invertFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.keyWordClick = keyWords => {
    if (!keyWords.trim()) {
      return;
    }
    const re = (keyWords.match(/["'](.*)["']/));

    if (re) {
      $scope.filter.addKeyword(re[1]);
    } else {
      keyWords.split(' ').forEach((keyword) => {
        $scope.filter.addKeyword(keyword);
      });
    }
    $scope.updateAsText();
  };

  $scope.removeFilter = f => {
    $scope.filter.removeFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.setCellFilter = (drill, cell) => {
    const filter = $scope.model.getCellFilter(drill, cell);
    $scope.filter.toggleFilter(filter);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.selectAll = () => {
    if (!$scope.aggregate || !$scope.aggregate.cells) {
      return;
    }
    const drill = $scope.filterBar.drilldown[0];
    const cells = $scope.aggregate.cells;
    cells.forEach(cell => {
      const filter = $scope.model.getCellFilter(drill, cell);
      $scope.filter.toggleFilter(filter);
    });
    $scope.CurrentFilterService.rebuildVisibleDimensions();
    $scope.RouterService.filterChanged();
  };

  const setTimeout = () => {
    if (!$scope.filter.timeout) {
      $scope.timeout = {
        hours: 0,
        minutes: 0
      };
    } else {
      let [h, m] = $scope.filter.timeout.split(':');
      if (!h || isNaN(Number(h))) h = 0;
      if (!m || isNaN(Number(m))) m = 0;
      $scope.timeout = {
        hours: Number(h),
        minutes: Number(m)
      };
    }
  };
  setTimeout();

  $scope.changeFilterTimeout = () => {
    if ($scope.timeout.minutes > 59) {
      $scope.timeout.minutes = 0;
    }
    if ($scope.timeout.minutes < 0) {
      $scope.timeout.minutes = 59;
    }
    if ($scope.timeout.hours < 0) $scope.timeout.hours = 0;
    $scope.filter.timeout = `${$scope.timeout.hours}:${$scope.timeout.minutes}`;
  };

  $scope.ok = testMail => {
    if ($scope.filter.content_type === 'deletepolicy') {
      $modal.open({
          templateUrl: 'boolDialog.html',
          controller: boolDialogCtrl,
          resolve: {
            message: () => gettext('Вы уверены в правильности выбора данных? Удалённые данные восстановить нельзя.')
          },
        })
        .result.then(result => {
          console.log(result);
          if (result) ok2(testMail);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      ok2(testMail);
    }
  };

  const ok2 = testMail => {
    $scope.filter.search_color = Number($scope.filter.search_color);
    $scope.awaiting = true;
    if (testMail) {
      $scope.testMail = false;
      $scope.filter.testmail = true;
      if (!$scope.filter.emails) $scope.filter.emails = $scope.notify2.adminMail;
    } else {
      delete $scope.filter.testmail;
    }

    if (filter.switch_to && !filter.switch_to.accountConf && !filter.switch_to.agentConf) delete filter.switch_to;
    $scope.successSended = false;
    $scope.findFilterError('save-filter');
    if ($scope.errorMessage.text) {
      return;
    }

    if (testMail && $scope.errorMessage.text) {
      $scope.testMail = true;
    }

    if (asNew) {
      $scope.filter.id = 0;
    }

    if ($scope.filter.isCardFilter) {
      delete $scope.filter.cardFilter;
      delete $scope.filter.children;
    }
    if ($scope.RouterService.isEditDasboard) $modalInstance.close($scope.filter);
    else FilterResource.save($scope.filter, function(status, data, error) {
      $scope.awaiting = false;

      if (error) {
        $scope.errorMessage.text = '';
        $scope.errorMessage.error = true;
        $scope.errorMessage.source = 'save-filter';
        if (typeof data == 'object') {
          $scope.errorMessage.fields = Object.keys(data).reduce((acc, k) => {
            const text = Array.isArray(data[k]) ? data[k].join(' ') : data[k];
            if (k in $scope.filter) acc[k] = text;
            else $scope.errorMessage.text = `${$scope.errorMessage.text} ${text}`;
            return acc;
          }, {});
        }
        if (testMail) $scope.testMail = true;
      } else {
        if (data.id) CurrentFilterService.FiltersService.loadedFilters[data.id] = true;
        if (testMail) $scope.testMail = true;
        if (status === 200) {
          if (!testMail) {
            $scope.ErrorHandlerService.notShowErrorMessageBox = false;
            $modalInstance.close(data);
          } else {
            let originalFilter = $scope.getOriginalFilter(data.id);
            if (!originalFilter) {
              originalFilter = new Filter();
              Object.assign(originalFilter, data);
              CurrentFilterService.FiltersService.filters.push(originalFilter);
            } else {
              Object.keys(originalFilter).map(k => delete originalFilter[k]);
              Object.assign(originalFilter, data);
            }
            $scope.filter = data;
            if (filter.notify || filter.reporting_schedule_type) {
              $scope.successSended = true;
              $scope.$timeout(() => $scope.successSended = false, 3000);
            }
            // RouterService.selectFilter(data.id);
          }
        }
      }
    });
  };

  $scope.cancel = () => {
    $scope.ErrorHandlerService.notShowErrorMessageBox = false;
    $modalInstance.dismiss('cancel');
    $scope.ErrorHandlerService.filterErrorMessage = {};
  };

  $scope.saveAs = () => {
    $scope.cancel();
    $timeout(() => {
      $scope.RouterService.FilterEditorService.saveFilter(true, $scope.filter);
      console.log('Open new filter...');
    }, 100);
  };


  $scope.delete = () => {
    $modal.open({
        templateUrl: 'boolDialog.html',
        controller: boolDialogCtrl,
        resolve: {
          message: () => ''
        },
      })
      .result.then(result => {
        if (result) {
          $scope.awaiting = true;
          $scope.filter.deleted = true;
          if ($scope.RouterService.isEditDasboard) $modalInstance.close($scope.filter);
          else return FilterResource.delete($scope.filter)
            .then(() => {
              $scope.awaiting = false;
              $scope.ErrorHandlerService.notShowErrorMessageBox = false;
              $modalInstance.close($scope.filter);
            })
            .catch((error) => {
              $scope.awaiting = false;
              globalAlert(error);
            });
        }
      })
      .catch((error) => {
        $scope.awaiting = false;
        console.error(error);
      });
  };

  $scope.show = {
    notify: () => true, // !$scope.filter.send_threshold,
    threshold: () => $scope.filter.send_threshold,
    sendPdf: () => $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter',
    splitByUser: () => $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter' && !filter.isCardOrDashboard,
    sendOptions: () => true,
    notifyTab: () => $scope.filter.content_type === 'filter' || $scope.filter.content_type === 'policy' ||
      $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.isDashboard || $scope.filter.isCard ||
      $scope.filter.content_type === 'filteraggregatealertfilter',
    filtersTab: () => !($scope.serverPolicies || $scope.filter.content_type === 'folder' || $scope.filter.content_type === 'mailgrabber' || $scope.filter.content_type === 'msgraphgrabber' || $scope.filter.content_type === 'contentprocessing'),
    category: () => $scope.filter.content_type === 'policy' || $scope.filter.content_type === 'corpusprocessfilter' ||
      $scope.filter.content_type === 'letteryourself',
    politicOptions: () => $scope.filter.content_type !== 'mailgrabber' && $scope.filter.content_type !== 'msgraphgrabber' && $scope.filter.content_type !== 'filter' &&
      $scope.filter.content_type !== 'dashboard' && $scope.filter.content_type !== 'folder' &&
      $scope.filter.content_type !== 'filteraggregatealertfilter' && $scope.filter.content_type != 'withdrawallicenseagent',
    lateUploadFilter: () => $scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter',
    corpusprocessfilter: () => $scope.filter.content_type === 'corpusprocessfilter',
    contentprocessing: () => $scope.filter.content_type === 'contentprocessing',
    assignAgentConfigTab: () => $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.content_type === 'policy' || $scope.filter.content_type === 'filter',
    backupfilter: () => $scope.filter.content_type === 'backupfilter',
    mailgrabber: () => $scope.filter.content_type === 'mailgrabber',
    msgraphgrabber: () => $scope.filter.content_type === 'msgraphgrabber',
    ocrparser: () => $scope.filter.content_type === 'ocrparser',
    stamprecognition: () => $scope.filter.content_type === 'stamprecognition',
    graphicobjects: () => $scope.filter.content_type === 'graphicobjects',
    withdrawallicenseagent: () => $scope.filter.content_type === 'withdrawallicenseagent',
    use_cp_service: () => $scope.filter.content_type === 'facedetector',
    emailTemplete: () => $scope.emailTemplete.show,
    newEventsNotify: () => !$scope.filter.isDashboard && !$scope.filter.isCard,
    lens: () => ($scope.filter.content_type === 'filter' || $scope.filter.content_type === 'filteraggregatealertfilter') &&
      !$scope.filter.isPolitic && !$scope.filter.isContainer,
    saveAs: () => $scope.filter.saved && ($scope.filter.content_type === 'filter' || $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.content_type === 'policy'),
  };

  $scope.RegExpConstructor = () => {
    const regExpModalInstance = $modal.open({
        template: require('./regexp-constructor/regexp-constructor-modal.component.html'),
        controller: RegExpConstructorModalController,
        windowClass: 'regexp-constructor',
        resolve: {
          regExp: () => ''
        },
      })
      .result.then(refExp => {
        $scope.filter.corpus_data = `${$scope.filter.corpus_data}\n~${refExp}`;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  $scope.updateAsText();
};



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor-modal.component.js